import React from 'react';
import Autosuggest from 'react-autosuggest';
import { find, map, join } from 'ramda';
import {
    Link,
    useParams
} from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import SearchElement from './SearchElement';
import PrintCatalog from './PrintCatalog';
import './MenuTop.scss';
import ShareModal from './ShareModal';
import CatalogCSV from './CatalogCSV';



export default function MenuTop ({ horses, sale, favoritedHorses = [], consignorIDInt = null, showingFavorites = false }) {
    const consignorObj = find((c) => parseInt(c.consignor_id, 10) === consignorIDInt)(global.drupalSettings.catalogues.consignors_contacts);
    const main_color = consignorObj && consignorObj.main_color || global.drupalSettings.catalogues.main_color;
    const secondary_color = consignorObj && consignorObj.secondary_color || global.drupalSettings.catalogues.secondary_color;

    const favorites = join(',', map(
        (h => h.hip)
    )(favoritedHorses));

    const indexLinks = (
        <>
            <FontAwesomeIcon icon={['fas', 'bookmark']} />
            <Link to="/sale" className="btn full-index"
            >
                Full Index
            </Link>
            | 
            <Link to={`/consignor/${consignorIDInt}`} className="btn full-index"
            >
                View Consignor Index
            </Link>
        </>
    );

    const saleLinks = (
        <>
            <FontAwesomeIcon icon={['fas', 'bookmark']} />
            <Link to="/sale" className="btn full-index"
            >
                Sale Index
            </Link>
        </>
    );

    return (
        <div
            className="menu-top"
        >
          <SearchElement enhanced={true} />
          <div className="mt-controls">
            { favoritedHorses.length > 0 && <ShareModal url={`${window.location.href.replace(window.location.hash, '')}#/sale?favorites=${favorites}`} /> }
            <PrintCatalog horses={showingFavorites ? favoritedHorses : horses } sale={sale} saleId={global.drupalSettings.catalogues.previous_sale_id} />
            <CatalogCSV horses={showingFavorites ? favoritedHorses : horses } />

          </div>
          <div className="mt-index-jumps"
            style={{
                backgroundColor: `${main_color}`,
                color: secondary_color,
            }}
          >
                { consignorIDInt && indexLinks}
                { !consignorIDInt && saleLinks}
          </div>
          
        </div>
    );
}
